(function(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.eu-tab-btn,.eu-tab-phead');
    if(!btn)return;
    var shell=btn.closest('.eu-tabs-shell');
    if(!shell)return;
    var i=btn.getAttribute('data-i');
    shell.querySelectorAll('.eu-tab-btn').forEach(function(b){b.classList.toggle('is-active',b.getAttribute('data-i')===i);});
    shell.querySelectorAll('.eu-tab-panel').forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-i')===i);});
  });
  // FAQ: keep one answer open per panel
  document.addEventListener('toggle',function(e){
    var d=e.target;
    if(d.matches&&d.matches('.faq-item')&&d.open){
      var parent=d.parentElement;
      if(parent)parent.querySelectorAll(':scope > .faq-item').forEach(function(o){if(o!==d)o.open=false;});
    }
  },true);
})();
